import {
  Shield,
  UserPlus,
  CreditCard,
  FileCheck,
  ArrowRightLeft,
  ClipboardCheck,
  HelpCircle,
} from "lucide-react";
import { cn } from "../../lib/utils";

export interface ContextMeta {
  id: string;
  name: string;
  icon: string;
  color: string;
}

const CONTEXT_ICONS: Record<string, React.ReactNode> = {
  Shield: <Shield className="h-2.5 w-2.5" />,
  UserPlus: <UserPlus className="h-2.5 w-2.5" />,
  CreditCard: <CreditCard className="h-2.5 w-2.5" />,
  FileCheck: <FileCheck className="h-2.5 w-2.5" />,
  ArrowRightLeft: <ArrowRightLeft className="h-2.5 w-2.5" />,
  ClipboardCheck: <ClipboardCheck className="h-2.5 w-2.5" />,
};

/** Small pill badge shown on agent flow nodes for each attached context. */
export function ContextBadge({ context }: { context: ContextMeta }) {
  const icon = CONTEXT_ICONS[context.icon] ?? <HelpCircle className="h-2.5 w-2.5" />;
  return (
    <span
      className={cn(
        "inline-flex items-center gap-0.5 rounded-full border px-1.5 py-px text-[9px] font-medium",
        context.color,
      )}
      title={context.name}
    >
      {icon}
      <span className="leading-none">{context.name}</span>
    </span>
  );
}
